import { Dispatch, SetStateAction } from 'react';

import { TOperationType } from '../../modals/WarehouseModals/interfaces';
import { TGood } from '../../types';

export interface IGood {
  id: number;
  title: string;
  amount: number;
}

export type TGoodMap = Record<number, IGood>;

export interface SelectedGood {
  value: number;
  title: string;
  quantity: number | '';
  comment: string;
  amount: number;
}

export enum ETabs {
  ADD = 'add',
  DISCARD = 'discard',
}

export interface IChangeQuantityArgs {
  goodId: TGood['id'];
  quantity: number;
  operation: TOperationType;
  comment?: string;
}

export interface IReturnValue {
  changeQuantity: (args: IChangeQuantityArgs) => Promise<unknown>;
  loading: boolean;
}

export interface IWarehouseManagerReturnedData {
  selectedGoods: SelectedGood[];
  handleAddGood: (value: number | null) => void;
  handleUpdateGood: (
    index: number,
    key: keyof SelectedGood,
    newValue: number | string | null
  ) => void;
  handleRemoveGood: (index: number) => void;
  handleFormSubmit: () => Promise<void>;
  setSelectedGoods: Dispatch<SetStateAction<SelectedGood[]>>;
  successCount: number;
  loading: boolean;
  isProcessingWarehouse: boolean;
}
